export const DEFAULT_ICON_WIDTH = 84;
export const DEFAULT_BACKGROUND_URL = '/img/card/bg-competition.jpg';
